module.exports = __webpack_public_path__ + "static/media/balloon-large.a9375cc5.svg";